/**
 * Lưu queue access token vào sessionStorage — clear khi đóng tab.
 * Inject vào header X-Queue-Token cho POST/DELETE /api/registration.
 */
const KEY = "queue_token";

export const setQueueToken = (token: string) => {
    sessionStorage.setItem(KEY, token);
};

export const getQueueToken = (): string | null => {
    return sessionStorage.getItem(KEY);
};

export const clearQueueToken = () => {
    sessionStorage.removeItem(KEY);
};
